import { ReactNode } from "react";
import { Provider } from "react-redux";
import { store } from "../store";
import { ThemeProvider } from "./ThemeProvider";
import { AuthProvider } from "./AuthProvider";
import { QueryProvider } from "./QueryProvider";
import { LoadingProvider } from "@/shared/loading";
import { ToastContainer } from "@/shared/toast";
import { ChatbotWidget } from "@/shared/chatbot";
import { ProfilerProvider } from "./ProfilerProvider";

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <Provider store={store}>
      <ProfilerProvider>
        <ThemeProvider>
          <QueryProvider>
            <LoadingProvider>
              <AuthProvider>{children}</AuthProvider>
              <ToastContainer />
              <ChatbotWidget />
            </LoadingProvider>
          </QueryProvider>
        </ThemeProvider>
      </ProfilerProvider>
    </Provider>
  );
};
